export const sourceFileStatus = {
	PENDING: 0,
	RECEIVED: 1,
	MISSING: 2,
	UNEXPECTED: 3,
};
export function getSourceFileStatusName(type) {
	let name = "";
	switch (type) {
		case sourceFileStatus.PENDING:
			name = "Pending";
			break;
		case sourceFileStatus.RECEIVED:
			name = "Received";
			break;
		case sourceFileStatus.MISSING:
			name = "Missing";
			break;
		case sourceFileStatus.UNEXPECTED:
			name = "Unexpected";
			break;
		default:
			break;
	}
	return name;
}

export const normalizationStatus = {
	PENDING: "pending",
	COMPLETE: "complete",
	FAILED: "failed",
	IN_PROGRESS: "in_progress",
};

export function getNormalizationStatusName(type) {
	let name = "";
	switch (type) {
		case normalizationStatus.PENDING:
			name = "Pending";
			break;
		case normalizationStatus.COMPLETE:
			name = "Completed";
			break;
		case normalizationStatus.IN_PROGRESS:
			name = "In Progress";
			break;
		case normalizationStatus.FAILED:
			name = "Failed";
			break;
		default:
			break;
	}
	return name;
}

export const isSameNormalizeCounts = (
	normalizationLineItemCount,
	sourceDataLineItemCount,
) => normalizationLineItemCount !== sourceDataLineItemCount;

export const getSourceFileName = (value?: string) => {
	if (!value) return "";

	if (value.startsWith("Residuals Fiserv Concord nonprocessing")) {
		return value.replace("nonprocessing ", "");
	}

	return value;
};
